import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import OnboardingGate from "@/components/OnboardingGate";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Onboarding from "@/pages/Onboarding";
import AcceptInvite from "@/pages/AcceptInvite";
import Dashboard from "@/pages/Dashboard";
import Documents from "@/pages/Documents";
import DocumentDetail from "@/pages/DocumentDetail";
import UploadDocument from "@/pages/UploadDocument";
import PrepareDocument from "@/pages/PrepareDocument";
import PrepareTemplate from "@/pages/PrepareTemplate";
import Templates from "@/pages/Templates";
import ApiDocs from "@/pages/ApiDocs";
import Analytics from "@/pages/Analytics";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";
import Security from "@/pages/Security";
import Signer from "@/pages/Signer";
import AuditCertificate from "@/pages/AuditCertificate";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
            {/* Public */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/invite/:token" element={<AcceptInvite />} />
            <Route path="/sign/:token" element={<Signer />} />

            {/* Onboarding */}
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <Onboarding />
                </ProtectedRoute>
              }
            />

            {/* App */}
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <OnboardingGate />
                </ProtectedRoute>
              }
            >
              <Route element={<Layout />}>
                <Route index element={<Dashboard />} />
                <Route path="documents" element={<Documents />} />
                <Route path="documents/upload" element={<UploadDocument />} />
                <Route path="documents/:id" element={<DocumentDetail />} />
                <Route path="documents/:id/prepare" element={<PrepareDocument />} />
                <Route path="documents/:id/certificate" element={<AuditCertificate />} />
                <Route path="templates" element={<Templates />} />
                <Route path="templates/:id/edit" element={<PrepareTemplate />} />
                <Route path="integrations/docs" element={<ApiDocs />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="team" element={<Team />} />
                <Route path="settings" element={<Settings />} />
                <Route path="profile" element={<Profile />} />
                <Route path="security" element={<Security />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
